import { FILTER_KEYS } from '../consts';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DEFAULT_PAGE_NUM, ALL } from 'shared/consts/giftCards';
import { UrlParams } from 'shared/types/giftCards';

function useFilters() {
  const [searchParams] = useSearchParams();

  const queryParams = useMemo(() => {
    const resultParams = {} as UrlParams;

    const pageNumParam = searchParams.get(FILTER_KEYS.pageNum);
    resultParams.pageNum = pageNumParam || String(DEFAULT_PAGE_NUM);

    for (const filterName of Object.values(FILTER_KEYS).filter((e) => e !== FILTER_KEYS.pageNum)) {
      const filterQueryParam = searchParams.get(filterName);
      if (filterQueryParam) {
        resultParams[filterName as keyof UrlParams] = filterQueryParam;
      } else if ([FILTER_KEYS.status, FILTER_KEYS.productId].includes(filterName)) {
        resultParams[filterName as keyof UrlParams] = ALL;
      }
    }

    return resultParams;
  }, [searchParams]);

  return queryParams;
}

export default useFilters;
